import Permission from "@/api/Permission";

export const permission = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async listPermissions() {
            return new Promise((resolve, reject) => {
                Permission.all()
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
    }
}